<template>
    <div class="header">
      <h1>QRCode 生成器</h1>
    </div>
</template>

<script>
export default {
  name: 'HomeHeader',
};
</script>

<style scoped>
.header {
  text-align: center;
}

@media only screen and (min-width: 50em) {
    .header h1 {
      font-size: 2em;
    }
}

@media only screen and (min-width: 30.0625em ) and (max-width: 50em) {
    .header h1 {
      font-size: 1.8em;
    }
}

@media only screen and (max-width: 30.0625em) {
    .header h1 {
      font-size: 1.6em;
    }
}


</style>



// WEBPACK FOOTER //
// src/views/components/Header.vue